import React from "react";
import NewExerciseForm from "./ExerciseForm/NewExerciseForm";
import LockExercise from "./LockExercise";
import { withTranslation } from "react-i18next";

class NewExercisePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      image_url: "",
      enrolmentData: null,
      exerciseData: null,
      recaptchaSiteKey: null,
      mobileFriendly: null,
      isLocked: 0,
    };
  }

  componentDidMount() {
    const onPageLoad = () => {
      try{
        const { name, image_url } = window.historylab.exerciseData.exercise;
        const isLocked = window.historylab.exerciseData.isLocked || 0;
        const enrolmentData = window.historylab.exerciseData.enrolment;
        const exerciseData = window.historylab.exerciseData;
        const recaptchaSiteKey = window.historylab.env.REACT_APP_RECAPTCHA_SITEKEY;
        const mobileFriendly = window.historylab.exerciseData.exercise.mobileData.mobileFriendly;
        this.setState({name, image_url, enrolmentData, exerciseData, recaptchaSiteKey, mobileFriendly, isLocked});
      }
      catch (e){
        console.error(e);
        this.props.history.push("/chyba/500");
      }
    };

    // Check if the page has already loaded
    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener("load", onPageLoad);
    }
  }

  render() {
    return (
      <>
        {this.state.isLocked && (
          <LockExercise
            exerciseName={this.state.name}
            exerciseBackgroundImage={this.state.image_url}
            requiredData={this.state.exerciseData}
          />
        )}
        {!this.state.isLocked && (
          <NewExerciseForm
            exerciseName={this.state.name}
            slug={this.props.match.params.slug}
            exerciseBackgroundImage={this.state.image_url}
            enrolmentData={this.state.enrolmentData}
            requiredData={this.state.exerciseData}
            recaptchaSiteKey={this.state.recaptchaSiteKey}
            mobileFriendly={this.state.mobileFriendly}
          />
        )}
      </>
    );
  }
}

export default withTranslation()(NewExercisePage);
